



























import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { mapState } from 'vuex'
import StatsService from '~/services/stats/StatsService'
import { setUrlParam } from '~/utils/http'
import { Size } from '~/models/app/size'

export default defineComponent({
  props: {
    link: {
      type: String,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as PropType<Size>,
      default: Size.MD
    },
    rounded: {
      type: Boolean,
      default: false
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    icons: {
      shoppingCart: faShoppingCart
    }
  }),
  computed: {
    ...mapState({
      classifiedId: state => state.classifieds.view.classified.id
    }),
    linkWithRef() {
      return setUrlParam(this.link, 'ref', 'car.gr')
    }
  },
  methods: {
    recordStat() {
      const statsService = this.$dep(StatsService)
      statsService.record('events.clsfds.buy_it_click', [this.classifiedId])
      this.$analytics.recordEvent({
        namespace: 'n_classifieds_view_buyit-btn',
        action: 'click'
      })
    }
  }
})
